import { render, staticRenderFns } from "./grid-col-responsive-editor.vue?vue&type=template&id=06dc7f62&scoped=true"
import script from "./grid-col-responsive-editor.vue?vue&type=script&lang=js"
export * from "./grid-col-responsive-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dc7f62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06dc7f62')) {
      api.createRecord('06dc7f62', component.options)
    } else {
      api.reload('06dc7f62', component.options)
    }
    module.hot.accept("./grid-col-responsive-editor.vue?vue&type=template&id=06dc7f62&scoped=true", function () {
      api.rerender('06dc7f62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/container-grid-col/grid-col-responsive-editor.vue"
export default component.exports